import React from 'react'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    style : {  
        fontSize: "8px",
        borderTop: "1px solid #E7E7E7",
        textAlign: "center",
        padding: "1px",
        position: "fixed",
        left: "0",
        bottom: "0",
        height: "35px",
        width: "100%",
      },
      
    phantom : {
        display: "block",
        padding: "1px",
        height: "35px",
        width: "100%",
    },
    
    rootDiv : {
        visibility: "hidden",
        '@media print': {
            visibility: "visible",
            pageBreakAfter: "always",
        },
    },

});

const Footer=({children})=>{
    const classes = useStyles();
    return(
        <div className={classes.rootDiv}>
            <div className={classes.phantom} />
            <div className={classes.style}>
                <p>{ children }</p>
            </div>
        </div>
    )
}

export default Footer;